import { QuoteV2 } from 'types'

export const shouldSeeOwnershipAdditionalQuestions = (
  requiredAdditionalQuestions: QuoteV2['requiredAdditionalQuestions'],
): boolean =>
  requiredAdditionalQuestions.some((item) =>
    ['vehicle-registered-keeper', 'vehicle-legal-owner'].includes(item),
  )
